import React from 'react';
import { useState, useEffect } from 'react';
import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

const Registration = () => {
  return (
    <>
      <div>

        <Box height={100} />

          <Grid container spacing={0} alignItems="center" justify="center">
                <Grid item xs={2} />
                <Grid item xs={8}>
                  <Card>
                    <CardHeader title='课程注册'/>
                    <CardContent>
                      <Box textAlign={'left'}>
 
                        <Typography variant="body1" gutterBottom>
                        返校学生以及新学生请按照<Link href="/documents/RACL-Registration-System-Manual-Chinese.pdf" color="primary" underline="none">
                            在线注册系统步骤说明
                          </Link>
                          使用
                                <Link href="https://user.racl.org" color="primary" underline="none">
                                   {` TriCLS 在线注册系统 `}
                                </Link>
                         完成注册。如果您忘记了家庭帐户密码，您可以从登录页面重置密码。 如果您仍有问题，请通过 <a href='mailTo:registration@racl.org' target='_blank'>registration@racl.org</a> 与我们联系。                       
                        </Typography>
                           <br/>
                        <Typography variant="body1" gutterBottom>
                        除Pre-Kindergarten和Kindergarten新生外，TriCLS工作人员会联系家长做新生测试评估以便分配班级。Pre-Kindergarten和Kindergarten新生需要提供出生证明原件或公立学校录取通知书以证明新学生的年龄。
                        </Typography>
                           <br/>
                        <Typography variant="body1" gutterBottom>
                        我们的课程在 Apex 中学的设施内定期进行，周六上午 9:15 至11：00 中文语言课以及11:15 至中午 12:00 课外活动课。 今年，我们将开设大约四十个汉语班和三十个文化活动班。 我们欢迎所有返校学生、最近满 4 岁的新生以及最近搬到三角区的学生加入我们。
                        </Typography>
                           <br/>
                        <Typography variant="body1" gutterBottom>
                          在我们的语言教学中，我们采用了简体汉字和“拼音”发音系统。 为满足社区不同背景和水平学生的需求，我们提供三种不同的汉语课程：中文（使用暨南大学中文教材包括拼音)）、CSL-child（汉语作为儿童第二语言）和CSL- 成人（成人第二语言中文）。 我们的文化和活动课程旨在增强学生在舞蹈、绘画、趣味数学、SAT、乒乓球，羽毛球，国际象棋等方面的广泛学习体验。您将在完成注册以后发现具体课程目录及上课时间。
                        </Typography>
                        <br/>
                        <Typography variant="body1" gutterBottom>
                          Returning students and new students please complete the registration by using the 
                                <Link href="https://user.racl.org" color="primary" underline="none">
                                   {` TriCLS Online Registration System `}
                                </Link>
                          and following the 
                          {/* <Link href={`${process.env.PUBLIC_URL}/uploads/RACL-Registration-System-Manual-English.pdf`} color="primary" underline="none">
                            {` Class Registration Instructions `}
                          </Link>. If you forgot your family account password, you can reset it from the login page. If you still have a problem, please contact us at <a href='mailTo:registration@racl.org' target='_blank'>registration@racl.org</a>.  */}

                          <Link href={`/documents/RACL-Registration-System-Manual-English.pdf`} color="primary" underline="none">
                            {` Class Registration Instructions `}
                          </Link>. If you forgot your family account password, you can reset it from the login page. If you still have a problem, please contact us at <a href='mailTo:registration@racl.org' target='_blank'>registration@racl.org</a>. 
                        </Typography>                                                   
                          <br/>
                        <Typography variant="body1" gutterBottom>
                          For the new students except for the new kindergarteners and pre-kindergarteners, our staff will reach out to the parents directly for the class assignment evaluation before the new semester starts. An original birth certificate or a public school admission letter is required to prove the age of a new pre-kindergarten or kindergarten student.
                        </Typography>
                          <br/>
                        <Typography variant="body1" gutterBottom>
                          Our classes are conducted regularly at Apex Middle School on Saturdays from 9:15AM to 11:00AM for Chinese language classes and 11:15AM to 12:00PM for activity classes. This year, we offer approximately forty Chinese language classes and thirty culture and activity classes. We welcome all returning students, new students who have recently reached the age of 4, and those students who have recently moved to the Triangle area.
                        </Typography>
                           <br/>
                        <Typography variant="body1" gutterBottom>  
                          In our language instruction, we have adopted simplified Chinese characters and the “Pinyin” pronunciation system. To meet the needs of various backgrounds and leveled students in our community, we offer three different tracks of Chinese language classes: Zhong-Wen (traditional pinyin-based textbooks), CSL-child (Chinese as Second Language for Children), and CSL-Adult (Chinese as Second Language for Adults). Our culture and activity classes are designed to enhance students’ broad learning experiences in Dancing, Drawing, Fun Math, SAT, Ping-Pong, badminton,chess among others. You will find the details once you finish the registration in the TriCLS registration system. 
                        </Typography>
   

                      </Box>
                    </CardContent>
                  </Card>

                </Grid> 
                <Grid item xs={2} />
            </Grid>
      
      </div>


     <Box height={80} />
    </>
  )
}

export default Registration